// All helpers accept the domain-driven shape: { unit, block, project, contract, client, financials, payments }

import { capitalize } from "./format";

export const isUnitSold = (data) => !!data?.contract;

export const getPricePerSqm = (data) => {
  const sqm = data?.unit?.net_sqm;
  const price = data?.financials?.settled_price;
  return sqm && price ? Math.round(price / sqm) : 0;
};

export const getPriceDifference = (data) => {
  const settled = data?.financials?.settled_price;
  const initial = data?.unit?.initial_price;
  return settled != null && initial != null ? settled - initial : null;
};

export const getPriceDiffPercent = (data) => {
  const initial = data?.unit?.initial_price;
  const diff = getPriceDifference(data);
  return diff != null && initial ? ((diff / initial) * 100).toFixed(1) : null;
};

export const getTotalArea = (data) =>
  (data?.unit?.net_sqm || 0) + (data?.unit?.terrace_net_sqm || 0);

export const getClientDisplayName = (client) => {
  if (!client) return '—';
  if (client.buyer_type === 'LEGAL') return capitalize(client.company) || '—';
  return [capitalize(client.name), capitalize(client.surname)].filter(Boolean).join(' ') || '—';
};

export const getDaysUntilDue = (nextDueDate) => {
  if (!nextDueDate) return null;
  return Math.ceil((new Date(nextDueDate) - new Date()) / (1000 * 60 * 60 * 24));
};
